  const generateSrcset = (image, widths = []) => {
    const imageUrl = new URL(image["src"]);
    return widths.filter((width) => width <= image["width"]).map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    }).join(", ");
  }

  const createImageElement = (image, classes, sizes, productTitle) => {
    const previewImage = image["preview_image"];
    const newImage = new Image(previewImage["width"], previewImage["height"]);
    newImage.className = classes;
    newImage.alt = image["alt"] || productTitle;
    newImage.sizes = sizes;
    newImage.src = previewImage["src"];
    newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
    newImage.loading="lazy"
    return newImage;
  }

  // Secondary product-card images are rendered with data-src/data-srcset so they
  // are not downloaded on mobile (they only appear on desktop hover). Load them
  // only on hover-capable (i.e. non-touch) devices.
  const canHover = () => window.matchMedia && window.matchMedia('(hover: hover)').matches;

  const loadHoverImages = () => {
    if (!canHover()) return;
    document.querySelectorAll('img.media--second[data-srcset], img.media--second[data-src]').forEach((img) => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
    });
  };

  // Cards can be injected after page load (e.g. product-recommendations
  // "You May Also Like", quick-add, quickview). Watch for newly added
  // secondary images and load them on hover-capable devices.
  const observeHoverImages = () => {
    if (!canHover() || window.__hoverImgObserver) return;
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (
            node.matches?.('img.media--second[data-srcset], img.media--second[data-src]') ||
            node.querySelector?.('img.media--second[data-srcset], img.media--second[data-src]')
          ) {
            loadHoverImages();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.__hoverImgObserver = observer;
  };

  const checkSwatches = () => {
    document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
      wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
        input.addEventListener('click', (event) => {
          const primaryImage = wrapper.querySelector(".media--first");
          const secondaryImage = wrapper.querySelector(".media--second");
          const handleProduct = wrapper.dataset.product;
          
          if (event.currentTarget.checked && primaryImage) {
            wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
              wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
            }
            
            const currentColor = event.currentTarget.value;

            jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
              const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

              if (variant) {
                const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                
                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage && secondaryImage.src) {
                    const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove('media--second');
                      secondaryImage.classList.add('media--first');
                      flag = true;
                    } 
                  }
                  if (flag == false) {
                    primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                    setTimeout(function(){
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                      if (secondaryImage) {
                        secondaryImage.remove();                                    
                      }
                    }, 200);
                  }
                }
              }
            });
          }
        })
      })
    })
  }

  function colorSwatches() {
    checkSwatches();
    loadHoverImages();
    observeHoverImages();

    document.addEventListener('shopify:section:load', function () {
      checkSwatches();
      loadHoverImages();
    });
  }

(function () {
  colorSwatches();
})()